import React,{useState,useRef,useEffect} from 'react'
import _ from 'lodash'
import { Formik, Field } from 'formik'
import axios from 'axios'

import { Form, Input, TextArea, Button, Table } from 'semantic-ui-react'

import { WindowReload, WindowURL } from '../../services/redirect'
import Paginations from '../../services/paginations'
import EntryList from '../../services/entries'
import Spinner from '../../services/spinner'

export default function EditHistoryNotesComponent(props){


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [spinoverlay,setspinoverlay] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }



  /*----------------------------------------
    LIST DATA TABLE
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }

 
  function handleSubmitForm(values, props){
    if(buttonclick==1){
      props.resetForm();
      TableList(pagenumber,search);
    }else{
      let value={
        notes_id:values.notes_id,
        product:values.product,
        account:values.account,
        note:values.note
      }
      TableList(pagenumber,value);
    }
  }
   
  const [notesAccountId, setNotesAccountId] = useState('');
  const [search, setsearch]  = useState({
      notes_id:props.data_id,
      product:'',
      account:'',
      note:''
	});
  const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	  function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setspinner(true);

				let formData = new FormData();
				formData.append('type','list_history');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/processing-notes/request.php',formData)
				.then(function (response) {
          
						let obj = response.data;

						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable.array_data);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
                        setNotesAccountId(obj.listtable.account_id);
                        setspinner(false);
				})
				.catch(function (error){
          setspinner(false);
				});
	   }



  


  useEffect(()=>{
    TableList(pagenumber,search);
  },[]);

  return (
    <React.Fragment>


       {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
       {/*<Formik
            initialValues={search}
            onSubmit={handleSubmitForm}
            >
         {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {


         return(<React.Fragment>
           <div className="search-wrapper">
              <div className="search-body">
                <Form>
                    <Form.Group widths="equal">
                      <Field name="account">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Account</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                      </Field>
                      <Field name="product">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Product</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                      </Field>
                      <Field name="note">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Note</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                      </Field>
                    </Form.Group>
                 </Form>
              </div>
              <div className="search-footer">
                  <Button type="button" icon='sync alternate' size='tiny' className="LightGrayButton" content='Reset' onClick={() => buttonSubmit(1)}/>
                  <Button type="button" icon='search' size='tiny' className="GreenButton" content='Search' onClick={() => buttonSubmit(2)}/>
                  <button type="button" style={{'display':'none'}} ref={buttonEl} onClick={handleSubmit}></button>
              </div>
           </div>
        </React.Fragment>
         )}}
         </Formik>*/}



      {/*---------------------------------------------------------
          TABLE LIST SECTION
         --------------------------------------------------------*/}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {!spinner&&<React.Fragment>
      <div className="tableWrapper">
       <div className="panel-table">
   
         {/*<div className="panel-table-header">
           <div>{entry>0&&<EntryList entrycallback={entry} entryType={entrytype} lengthCallback={totaldata} callbackreload={listreload}/>}</div>
           <div>
             <Button className='LightGrayButton strong' size='tiny' content='Back to Processing Note List' icon='arrow left icon' as="a" href={WindowURL('/processing-notes/list')}/>
           </div>
         </div>*/}

         <div className="panel-table-body">
         <div className="table-responsive overflow">
           <Table celled compact='very'>
             <Table.Header>
               <Table.Row>
                 <Table.HeaderCell>Notes ID</Table.HeaderCell>
                 <Table.HeaderCell>Version</Table.HeaderCell>
                 <Table.HeaderCell>Account Number</Table.HeaderCell>
                 <Table.HeaderCell>Account Name</Table.HeaderCell>
                 <Table.HeaderCell>Product</Table.HeaderCell>
                 <Table.HeaderCell>Quantity</Table.HeaderCell>
                 <Table.HeaderCell>Price</Table.HeaderCell>
                 <Table.HeaderCell>Carriage</Table.HeaderCell>
                 <Table.HeaderCell>Handling Fee</Table.HeaderCell>
                 <Table.HeaderCell>Note</Table.HeaderCell>
                 <Table.HeaderCell>Date</Table.HeaderCell>
               </Table.Row>
             </Table.Header>

             <Table.Body>
                   {list.length==0&&<Table.Row negative><Table.Cell  colSpan='11' textAlign="center">No record found</Table.Cell></Table.Row>}
                   {list.map(function(data, key){
                     return <Table.Row key={key} verticalAlign='top'>
                          <Table.Cell>{data.notes_account}</Table.Cell>
                          <Table.Cell>{data.version_num}</Table.Cell>
                          <Table.Cell>{data.account_number}</Table.Cell>
                          <Table.Cell>{data.account_name}</Table.Cell>
                          <Table.Cell>
                            <div className="descriptionTable">
                              <div>
                                  <div style={{'opacity':'0.8'}}>{data.product_code}</div>
                                  <div>{data.product_name}</div>
                              </div>
                            </div>
                         </Table.Cell>
                         <Table.Cell>{data.quantity}</Table.Cell>
                         <Table.Cell>{data.price}</Table.Cell>
                         <Table.Cell>{data.carriage}</Table.Cell>
                         <Table.Cell>{data.handling_fee}</Table.Cell>
                         <Table.Cell>{data.note}</Table.Cell>
                         <Table.Cell collapsing>
                            <div className="descriptionTable">
                              <div>
                                  <h3>{data.date_added}</h3>
                                  <p>{data.date_time}</p>
                              </div>
                            </div>
                         </Table.Cell>
                     </Table.Row>
                   })}
               </Table.Body>
               {list.length>0&&
                 <Table.Footer fullWidth>
                     <Table.Row>
                     <Table.HeaderCell colSpan='11'>
                         <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
                     </Table.HeaderCell>
                     </Table.Row>
                 </Table.Footer>
               }
           </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
      </div>

      </React.Fragment>}

    </React.Fragment>
  )
}
